import type { InboxItem, InboxItemType } from '@/hooks/use-inbox'

/**
 * ADR-0015 three-surface rule: agent_chat threads belong in Chats, not Inbox triage.
 * @see docs/architecture/decisions/0015-chat-surface-model-threads-spine-multi-chrome.md
 */
export function isAgentChatInboxItem(item: InboxItem): boolean {
  const kind = item.meta?.threadKind
  if (kind === 'agent_chat') return true
  return item.type === 'agent_message'
}

/** Threads that belong in Inbox triage (voice, flows output, extensions, suggestions). */
export function isInboxTriageItem(item: InboxItem): boolean {
  return !isAgentChatInboxItem(item)
}

export function filterInboxTriageItems(items: InboxItem[]): InboxItem[] {
  return items.filter(isInboxTriageItem)
}

/** Display label for inbox triage rows on Home and sidebar. */
export function inboxTriageTypeLabel(type: InboxItemType): string {
  switch (type) {
    case 'voice_memo':
      return 'Voice'
    case 'flow_output':
      return 'Flow'
    case 'external':
      return 'External'
    case 'suggestion':
      return 'Suggestion'
    default:
      return 'Inbox'
  }
}
